<template>
  <footer class="common-footer">
    <div class="footer-content">
      <!-- 左侧二维码区域 -->
      <div class="footer-left">
        <div class="qr-codes">
          <!-- <div class="qr-item">
            <div class="qr-code-placeholder">
              <img
                :src="FooterConfig.weChatAppletImg"
                alt="小程序二维码"
              >
            </div>
            <div class="qr-label">
              深圳市版权公共服务平台<br>小程序
            </div>
          </div> -->
          <div class="qr-item">
            <div class="qr-code-placeholder">
              <img
                :src="FooterConfig.weChatOfficialAccountImg"
                :alt="$t('footer.altOfficialQr')"
              >
            </div>
            <div class="qr-label">
              {{ $t('footer.officialAccount') }}<br>{{ $t('footer.officialAccountSub') }}
            </div>
          </div>
        </div>
      </div>
      
      <!-- 中间联系方式区域 -->
      <div class="footer-center">
        <div class="contact-title">
          {{ $t('footer.contactUs') }}
        </div>
        <div class="contact-info">
          <div class="contact-item">
            <span class="contact-label">{{ $t('footer.softwareRegistration') }}</span>
            <span class="contact-value">{{ FooterConfig.softwareRegistration }}</span>
          </div>
          <div class="contact-item">
            <span class="contact-label">{{ $t('footer.workRegistration') }}</span>
            <span class="contact-value">{{ FooterConfig.registration }}</span>
          </div>
          <div class="contact-item">
            <span class="contact-label">{{ $t('footer.evidenceSolidification') }}</span>
            <span class="contact-value">{{ FooterConfig.evidenceSolidification }}</span>
          </div>
          <div class="contact-item">
            <span class="contact-label">{{ $t('footer.membership') }}</span>
            <span class="contact-value">{{ FooterConfig.membership }}</span>
          </div>
          <div class="contact-item">
            <span class="contact-label">{{ $t('footer.email') }}</span>
            <span class="contact-value">{{ FooterConfig.email }}</span>
          </div>
          <div class="contact-item">
            <span class="contact-label">{{ $t('footer.address') }}</span>
            <span class="contact-value">{{ FooterConfig.address }}</span>
          </div>
        </div>
      </div>
      
      <!-- 右侧链接区域 -->
      <div class="footer-right">
        <div class="footer-links">
          <div class="link-group">
            <div class="link-title">
              {{ $t('footer.helpCenter') }}
            </div>
            <div
              class="link-item"
              @click="handleLinkClick('manual')"
            >
              {{ $t('footer.manual') }}
            </div>
            <div
              class="link-item"
              @click="handleLinkClick('faq')"
            >
              {{ $t('footer.faq') }}
            </div>
          </div>
          <div class="link-group">
            <div class="link-title">
              {{ $t('footer.aboutUs') }}
            </div>
            <div
              class="link-item"
              @click="handleLinkClick('about')"
            >
              {{ $t('footer.aboutPlatform') }}
            </div>
            <div
              class="link-item"
              @click="handleLinkClick('official')"
            >
              {{ $t('footer.officialWebsite') }}
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 底部版权信息 -->
    <div class="footer-bottom-wrapper">
      <div class="footer-bottom">
        <div class="copyright">
          <span>{{ $t('footer.copyrightPrefix') }} {{ copyrightYearText }} {{ $t('footer.copyrightSuffix') }}</span>
          <a
            class="icp"
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
          >{{ $t('footer.icp') }}</a>
        </div>
        <div class="footer-links-bottom">
          <span
            class="link"
            @click="handleLinkClick('privacy')"
          >{{ $t('footer.privacy') }}</span>
          <span class="divider">|</span>
          <span
            class="link"
            @click="handleLinkClick('terms')"
          >{{ $t('footer.terms') }}</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { ElMessage } from 'element-plus'
import { FooterConfig } from '@/config/footer'
import { listFunctionGuide } from '@/api/functionGuide'
import { getFirstGuideItem } from '@/utils/functionGuideUtils'
import { FooterConfigDataKeyEnum } from '@/enums/FooterConfigDataKeyEnum'

export default {
  name: 'CommonFooter',
  data() {
    return {
      FooterConfig
    }
  },
  computed: {
    copyrightYearText() {
      return `2009-${new Date().getFullYear()}`
    }
  },
  methods: {
    async navigateToPlatformGuide() {
      try {
        const res = await listFunctionGuide({
          pageNum: 1,
          pageSize: 500
        })
        const rows = res?.rows ?? res?.data?.rows ?? []
        const firstGuide = getFirstGuideItem(Array.isArray(rows) ? rows : [])
        if (!firstGuide?.id) {
          ElMessage.warning(this.$t('footer.noGuide'))
          return
        }
        await this.$router.push({
          name: 'ArticleDetail',
          query: { guideId: String(firstGuide.id) }
        })
      } catch (e) {
        console.error('navigateToPlatformGuide failed', e)
        ElMessage.error(this.$t('footer.guideLoadFail'))
      }
    },
    navigateToFooterRichContent(dataKey) {
      this.$router.push({
        name: 'FooterRichContent',
        query: { dataKey }
      })
    },
    /**
     * 处理链接点击事件
     * @param {String} type - 链接类型
     */
    handleLinkClick(type) {
      switch (type) {
        case 'manual':
          this.navigateToPlatformGuide()
          break
        case 'faq':
          this.navigateToFooterRichContent(FooterConfigDataKeyEnum.COMMON_QUESTION.code)
          break
        case 'about':
          this.navigateToFooterRichContent(FooterConfigDataKeyEnum.ABOUT_PLATFORM.code)
          break
        case 'official':
          // 打开官网
          window.open('https://www.scs.org.cn/', '_blank')
          break
        case 'privacy': {
          const privacyRoute = this.$router.resolve({ name: 'UserPrivacyPolicy' })
          window.open(privacyRoute.href, '_blank', 'noopener,noreferrer')
          break
        }
        case 'terms': {
          const termsRoute = this.$router.resolve({ name: 'UserRegisterAgreement' })
          window.open(termsRoute.href, '_blank', 'noopener,noreferrer')
          break
        }
        default:
          console.log('未知链接类型:', type)
      }
      
      // 触发链接点击事件，供父组件监听
      this.$emit('link-click', type)
    }
  }
}
</script>

<style lang="scss" scoped>
.common-footer {
  background: #111111;
  color: #ffffff;
  padding: 40px 20px 20px;
  margin-top: auto;

  .footer-content {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: auto 1fr auto;
    gap: 50px;
    margin-bottom: 30px;
  }

  .footer-left {
    .qr-codes {
      display: flex;
      gap: 30px;
      justify-content: flex-start;

      .qr-item {
        text-align: center;

        .qr-code-placeholder {
          width: 100px;
          height: 100px;
          background-color: #ffffff;
          border-radius: 6px;
          margin: 0 auto 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          
          img {
            width: 100%;
            height: 100%;
            border-radius: 6px;
            object-fit: cover;
          }
        }

        .qr-label {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.95);
          line-height: 1.5;
        }
      }
    }
  }

  .footer-center {
    .contact-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 16px;
      color: #ffffff;
    }

    .contact-info {
      .contact-item {
        display: flex;
        align-items: flex-start;
        margin-bottom: 10px;
        font-size: 13px;
        line-height: 1.6;

        .contact-label {
          min-width: 30px;
          margin-right: 8px;
          color: rgba(255, 255, 255, 0.9);
        }

        .contact-value {
          color: #ffffff;
          flex: 1;
        }
      }
    }
  }

  .footer-right {
    .footer-links {
      display: flex;
      gap: 60px;

      .link-group {
        .link-title {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 16px;
          color: #ffffff;
        }

        .link-item {
          font-size: 13px;
          margin-bottom: 10px;
          cursor: pointer;
          color: rgba(255, 255, 255, 0.9);
          transition: all 0.3s;
          padding: 4px 0;

          &:hover {
            color: #ffffff;
            text-decoration: underline;
          }
        }
      }
    }
  }

  .footer-bottom-wrapper {
    background: #000000;
    margin: 0 -20px -20px;
    padding: 25px 20px 20px;
    border-top: 1px solid rgba(255, 255, 255, 0.15);
  }

  .footer-bottom {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;

    .copyright {
      font-size: 12px;
      color: rgba(255, 255, 255, 0.9);
      
      .icp {
        margin-left: 15px;
        color: inherit;
        text-decoration: none;
        transition: all 0.3s;

        &:hover {
          color: #ffffff;
          text-decoration: underline;
        }
      }
    }

    .footer-links-bottom {
      display: flex;
      align-items: center;
      gap: 10px;

      .link {
        font-size: 12px;
        cursor: pointer;
        color: rgba(255, 255, 255, 0.9);
        transition: all 0.3s;

        &:hover {
          color: #ffffff;
          text-decoration: underline;
        }
      }

      .divider {
        color: rgba(255, 255, 255, 0.6);
      }
    }
  }
}

// 响应式设计
// iPad 及小平板（≤1200px）：改为纵向堆叠并居中
@media (max-width: 1200px) {
  .common-footer {
    padding: 35px 20px 15px;
    box-sizing: border-box;

    .footer-content {
      grid-template-columns: 1fr;
      gap: 32px;
      padding: 0 8px;
    }

    .footer-left {
      width: 100%;

      .qr-codes {
        justify-content: center;
        gap: 28px;
        flex-wrap: wrap;
      }
    }

    .footer-center {
      width: 100%;
      max-width: 640px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;

      .contact-title {
        text-align: center;
      }

      .contact-info {
        display: inline-flex;
        flex-direction: column;
        align-items: stretch;
        width: auto;
        max-width: 100%;
        margin: 0 auto;
        text-align: left;

        .contact-item {
          justify-content: center;
          align-items: flex-start;
          flex-wrap: nowrap;
          width: 100%;
        }

        .contact-label {
          min-width: 72px;
          flex-shrink: 0;
          margin-right: 10px;
          text-align: right;
        }

        .contact-value {
          flex: 0 1 auto;
          min-width: 0;
          word-break: break-word;
          text-align: left;
        }
      }
    }

    .footer-right {
      width: 100%;

      .footer-links {
        justify-content: center;
        gap: 48px;
        flex-wrap: wrap;
      }

      .link-group {
        min-width: 120px;
        text-align: center;
      }
    }

    .footer-bottom-wrapper {
      margin: 0 -20px -15px;
      padding: 22px 20px 18px;
    }

    .footer-bottom {
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 14px;

      .copyright {
        line-height: 1.6;

        .icp {
          display: block;
          margin-left: 0;
          margin-top: 6px;
        }
      }

      .footer-links-bottom {
        justify-content: center;
        flex-wrap: wrap;
      }
    }
  }
}

// 移动端适配 (≤ 768px)
@media (max-width: 768px) {
  .common-footer {
    padding: 30px 15px 0;

    .footer-content {
      grid-template-columns: 1fr;
      gap: 30px;
    }

    .footer-left {
      .qr-codes {
        flex-direction: row;
        justify-content: center;
        align-items: flex-start;
        gap: 25px;

        .qr-item {
          .qr-code-placeholder {
            width: 90px;
            height: 90px;
          }

          .qr-label {
            font-size: 11px;
            margin-top: 8px;
          }
        }
      }
    }

    .footer-center {
      max-width: none;
      padding: 0 4px;

      .contact-title {
        font-size: 15px;
        margin-bottom: 14px;
      }

      .contact-info {
        display: inline-flex;
        flex-direction: column;
        align-items: stretch;
        width: auto;
        max-width: calc(100vw - 48px);
        margin: 0 auto;

        .contact-item {
          flex-direction: row;
          justify-content: center;
          align-items: flex-start;
          margin-bottom: 10px;
          font-size: 12px;
          text-align: left;
        }

        .contact-label {
          min-width: 68px;
          flex-shrink: 0;
          margin-right: 8px;
          margin-bottom: 0;
          font-weight: 500;
          text-align: right;
        }

        .contact-value {
          width: auto;
          flex: 0 1 auto;
          max-width: calc(100vw - 140px);
          text-align: left;
          word-break: break-word;
        }
      }
    }

    .footer-right {
      .footer-links {
        flex-direction: column;
        gap: 25px;
        align-items: center;

        .link-group {
          text-align: center;

          .link-title {
            font-size: 15px;
            margin-bottom: 12px;
          }

          .link-item {
            font-size: 12px;
            margin-bottom: 8px;
          }
        }
      }
    }

    .footer-bottom-wrapper {
      margin: 0 -15px 0;
      padding: 18px 15px 15px;
    }

    .footer-bottom {
      .copyright {
        font-size: 11px;

        .icp {
          margin-top: 6px;
        }
      }

      .footer-links-bottom {
        gap: 8px;

        .link {
          font-size: 11px;
        }

        .divider {
          display: none;
        }
      }
    }
  }
}

// 小屏幕手机适配 (≤ 480px)
@media (max-width: 480px) {
  .common-footer {
    padding: 25px 12px 0;

    .footer-content {
      gap: 25px;
    }

    .footer-left {
      .qr-codes {
        gap: 20px;

        .qr-item {
          .qr-code-placeholder {
            width: 80px;
            height: 80px;
          }

          .qr-label {
            font-size: 10px;
          }
        }
      }
    }

    .footer-center {
      .contact-title {
        font-size: 14px;
        margin-bottom: 12px;
      }

      .contact-info {
        max-width: calc(100vw - 36px);

        .contact-item {
          margin-bottom: 8px;
          font-size: 11px;
        }

        .contact-label {
          min-width: 60px;
          margin-right: 6px;
        }

        .contact-value {
          max-width: calc(100vw - 120px);
        }
      }
    }

    .footer-right {
      .footer-links {
        gap: 20px;

        .link-group {
          .link-title {
            font-size: 14px;
            margin-bottom: 10px;
          }

          .link-item {
            font-size: 11px;
            margin-bottom: 6px;
          }
        }
      }
    }

    .footer-bottom-wrapper {
      margin: 0 -12px 0;
      padding: 15px 12px 12px;
    }

    .footer-bottom {
      gap: 10px;

      .copyright {
        font-size: 10px;

        .icp {
          margin-top: 5px;
        }
      }

      .footer-links-bottom {
        .link {
          font-size: 10px;
        }
      }
    }
  }
}
</style>
